import React from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { MarkdownRender } from '@/components/ui/markdown-render';

type Event = {
  eventId: string;
  name: string;
  description: string;
  startDate: string;
  orgName: string | null;
  orgId: string | null;
}

export function UpcomingEvents() {
  // Fetch records
  const { data: events, isLoading, error } = useQuery({
    queryKey: ['events'],
    queryFn: async () => {
      const response = await fetch('/api/me/events');
      if (!response.ok) {
        throw new Error('Failed to fetch records');
      }
      return response.json() as Promise<Event[]>;
    },
  });


  return (
    <>
      <h2 className="text-3xl font-bold text-center mb-12">Upcoming Events</h2>

      {isLoading ? (
        <div className="flex justify-center p-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : error ? (
        <div className="bg-red-50 p-4 rounded-md text-red-800">
          Failed to load records. Please try again.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {events.map((event) => {
            return (
              <Card className='overflow-hidden'>
                <CardHeader>
                  <CardTitle>{event.name}</CardTitle>
                </CardHeader>
                <CardContent>
                  <MarkdownRender content={event.description} />
                </CardContent>
              </Card>
            )
          })}
        </div>
      )}
    </>
  )
}
